import layout from '@/layout'
const meta = { auth: true }

export default {
  path: '/sampleStockUI',
  component: layout,
  children: ((pre) => [
    {
      path: 'sampleTagPrint',
      name: `${pre}sampleTagPrint`,
      meta: {
        ...meta,
        cache: true,
        title: '样品标签打印',
        head: true,
        funcID: 'B0401',
        PID: 'B00'
      },
      component: () => import('@/views/backstage/sampleStockUI/sampleTagPrint')
    },
    {
      path: 'sampleStockIn',
      name: `${pre}sampleStockIn`,
      meta: {
        ...meta,
        cache: true,
        title: '样品入库单',
        head: true,
        funcID: 'B0402',
        PID: 'B00'
      },
      component: () => import('@/views/backstage/sampleStockUI/sampleStockIn')
    },
    {
      path: 'sampleStockIn/:pageType/:code?',
      name: `${pre}sampletockIn-detail`,
      meta: {
        ...meta,
        cache: true,
        title: '样品入库单信息',
        head: false,
        funcID: 'B0402',
        PID: 'B00'
      },
      component: () =>
        import('@/views/backstage/sampleStockUI/sampleStockIn/detail')
    },
    {
      path: 'sampleStockBorrow',
      name: `${pre}sampleStockBorrow`,
      meta: {
        ...meta,
        cache: true,
        title: '样品外借单',
        head: true,
        funcID: 'B0403',
        PID: 'B00'
      },
      component: () =>
        import('@/views/backstage/sampleStockUI/sampleStockBorrow')
    },
    {
      path: 'sampleStockBorrow/:pageType/:code?',
      name: `${pre}sampleStockBorrow-detail`,
      meta: {
        ...meta,
        cache: true,
        title: '样品外借单信息',
        head: false,
        funcID: 'B0403',
        PID: 'B00'
      },
      component: () =>
        import('@/views/backstage/sampleStockUI/sampleStockBorrow/detail')
    },
    {
      path: 'sampleStockReturn',
      name: `${pre}sampleStockReturn`,
      meta: {
        ...meta,
        cache: true,
        title: '样品归还单',
        head: true,
        funcID: 'B0404',
        PID: 'B00'
      },
      component: () =>
        import('@/views/backstage/sampleStockUI/sampleStockReturn')
    },
    {
      path: 'sampleStockReturn/:pageType/:code?',
      name: `${pre}sampleStockReturn-detail`,
      meta: {
        ...meta,
        cache: true,
        title: '样品归还单信息',
        head: false,
        funcID: 'B0404',
        PID: 'B00'
      },
      component: () =>
        import('@/views/backstage/sampleStockUI/sampleStockReturn/detail')
    },
    {
      path: 'sampleStockSale',
      name: `${pre}sampleStockSale`,
      meta: {
        ...meta,
        cache: true,
        title: '样品销售单',
        head: true,
        funcID: 'B0405',
        PID: 'B00'
      },
      component: () => import('@/views/backstage/sampleStockUI/sampleStockSale')
    },
    {
      path: 'sampleStockSale/:pageType/:code?',
      name: `${pre}sampleStockSale-detail`,
      meta: {
        ...meta,
        cache: true,
        title: '样品销售单信息',
        head: false,
        funcID: 'B0405',
        PID: 'B00'
      },
      component: () =>
        import('@/views/backstage/sampleStockUI/sampleStockSale/detail')
    },
    {
      path: 'sampleStockSaleReturn',
      name: `${pre}sampleStockSaleReturn`,
      meta: {
        ...meta,
        cache: true,
        title: '样品回购单',
        head: true,
        funcID: 'B0406',
        PID: 'B00'
      },
      component: () =>
        import('@/views/backstage/sampleStockUI/sampleStockSaleReturn')
    },
    {
      path: 'sampleStockSaleReturn/:pageType/:code?',
      name: `${pre}sampleStockSaleReturn-detail`,
      meta: {
        ...meta,
        cache: true,
        title: '样品回购单信息',
        head: false,
        funcID: 'B0406',
        PID: 'B00'
      },
      component: () =>
        import('@/views/backstage/sampleStockUI/sampleStockSaleReturn/detail')
    },
    {
      path: 'sampleStockCheck',
      name: `${pre}sampleStockCheck`,
      meta: {
        ...meta,
        cache: true,
        title: '样品盘点',
        head: true,
        funcID: 'B0407',
        PID: 'B00'
      },
      component: () =>
        import('@/views/backstage/sampleStockUI/sampleStockCheck')
    },
    {
      path: 'sampleStockCheck/:pageType/:code?',
      name: `${pre}sampleStockCheck-detail`,
      meta: {
        ...meta,
        cache: true,
        title: '样品盘点信息',
        head: false,
        funcID: 'B0407',
        PID: 'B00'
      },
      component: () =>
        import('@/views/backstage/sampleStockUI/sampleStockCheck/detail')
    },
    {
      path: 'sampleStockLocation',
      name: `${pre}sampleStockLocation`,
      meta: {
        ...meta,
        cache: true,
        title: '库存明细查询',
        head: true,
        funcID: 'B0408',
        PID: 'B00'
      },
      component: () => import('@/views/backstage/sampleStockUI/sampleStockLocation')
    },
    {
      path: 'sampleStockSummary',
      name: `${pre}sampleStockSummary`,
      meta: {
        ...meta,
        cache: true,
        title: '库存汇总查询',
        head: true,
        funcID: 'B0409',
        PID: 'B00'
      },
      component: () =>
        import('@/views/backstage/sampleStockUI/sampleStockSummary')
    },
    {
      path: 'sampleStockChangeLog',
      name: `${pre}sampleStockChangeLog`,
      meta: {
        ...meta,
        cache: true,
        title: '样品变动日志',
        head: true,
        funcID: 'B0410',
        PID: 'B00'
      },
      component: () => import('@/views/backstage/sampleStockUI/sampleStockChangeLog')
    },
    {
      path: 'billStockBatchReturn',
      name: `${pre}billStockBatchReturn`,
      meta: {
        ...meta,
        cache: true,
        title: '样品批量归还单',
        head: true,
        funcID: 'B0411',
        PID: 'B00'
      },
      component: () =>
        import('@/views/backstage/sampleStockUI/billStockBatchReturn')
    },
    {
      path: 'billStockBatchReturn/:pageType/:code?',
      name: `${pre}billStockBatchReturn-detail`,
      meta: {
        ...meta,
        cache: true,
        title: '样品批量归还单信息',
        head: false,
        funcID: 'B0411',
        PID: 'B00'
      },
      component: () =>
        import('@/views/backstage/sampleStockUI/billStockBatchReturn/detail')
    },
    {
      path: 'locationPrint',
      name: `${pre}locationPrint`,
      meta: {
        ...meta,
        cache: true,
        title: '库位打印',
        head: true,
        funcID: 'B0412',
        PID: 'B00'
      },
      component: () =>
        import('@/views/backstage/sampleStockUI/locationPrint')
    },
    {
      path: 'cartonTransfer',
      name: `${pre}cartonTransfer`,
      meta: {
        ...meta,
        cache: true,
        title: '纸箱转库单',
        head: true,
        funcID: 'B0413',
        PID: 'B00'
      },
      component: () =>
        import('@/views/backstage/sampleStockUI/cartonTransfer')
    },
    {
      path: 'cartonTransfer/:pageType/:code?',
      name: `${pre}cartonTransfer-detail`,
      meta: {
        ...meta,
        cache: true,
        title: ({ $route }) => {
          const { billCartonTransferNo = '' } = $route.query || {}
          return `纸箱转库单信息 | ${billCartonTransferNo || 'New'}`
        },
        head: false,
        funcID: 'B0413',
        PID: 'B00'
      },
      component: () =>
        import('@/views/backstage/sampleStockUI/cartonTransfer/detail')
    },
  ])('samplemanage-')
}
